module.exports = __webpack_public_path__ + "static/media/icon-recommendations.0e258856.svg";